// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__C9QWC","title":"Images90_title__18an9","images":"Images90_images__2pRID"};